import React from "react";
import {
  Card,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
} from "antd";
import {
  DollarOutlined,
} from "@ant-design/icons";

const { TextArea } = Input;

const ShippingInformation = () => {
  return (
    <Card
      title={
        <Space>
          <DollarOutlined />
          <span>
            Shipping & Additional Information
          </span>
        </Space>
      }
      style={{
        borderRadius: 14,
        marginTop: 20,
      }}
    >
      <Row gutter={[20, 4]}>
        <Col xs={24} md={8}>
          <Form.Item
            name="shippingCost"
            label="Shipping Cost"
          >
            <InputNumber
              min={0}
              precision={2}
              style={{
                width: "100%",
              }}
              size="large"
              placeholder="0.00"
            />
          </Form.Item>
        </Col>

        <Col xs={24} md={8}>
          <Form.Item
            name="shippingTerms"
            label="Shipping Terms"
          >
            <Select
              size="large"
              placeholder="Select Incoterm"
              options={[
                {
                  value: "FOB",
                  label:
                    "FOB - Free on Board",
                },
                {
                  value: "CIF",
                  label:
                    "CIF - Cost, Insurance, Freight",
                },
                {
                  value: "EXW",
                  label:
                    "EXW - Ex Works",
                },
                {
                  value: "DDP",
                  label:
                    "DDP - Delivered Duty Paid",
                },
              ]}
            />
          </Form.Item>
        </Col>

        <Col xs={24} md={8}>
          <Form.Item
            name="description"
            label="Notes / Description"
          >
            <TextArea
              rows={3}
              placeholder="Special instructions, delivery notes or other information..."
            />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};

export default ShippingInformation;